import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-coa-type',
  templateUrl: './edit-coa-type.component.html',
  styleUrls: ['./edit-coa-type.component.sass']
})
export class EditCoaTypeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
